__turbopack_context__.v({
  "actions": "_48vcWq_actions",
  "content": "_48vcWq_content",
  "details": "_48vcWq_details",
  "digest": "_48vcWq_digest",
  "page": "_48vcWq_page",
  "panel": "_48vcWq_panel",
  "summary": "_48vcWq_summary",
});
